import { render, staticRenderFns } from "./ButtonRadioGroup.vue?vue&type=template&id=6534f26c&scoped=true"
import script from "./ButtonRadioGroup.vue?vue&type=script&lang=js"
export * from "./ButtonRadioGroup.vue?vue&type=script&lang=js"
import style0 from "./ButtonRadioGroup.vue?vue&type=style&index=0&id=6534f26c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6534f26c",
  null
  
)

export default component.exports